import React from 'react'
import MarketingManagerAddZonalCoordinator from '../../features/marketingManager/MarketingManagerAddZonalCoordinator'

const MarketingManagerAddZonalCoordinatorPage = () => {
    return (
        <MarketingManagerAddZonalCoordinator />
    )
}

export default MarketingManagerAddZonalCoordinatorPage
